<template>
	<div class="find-teams page">
		<div class="shell">
			<div class="find-teams__content">
				<div class="find-teams__content-input">
					<div class="icon">
						<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.7812 13.8438L12.6562 10.7188C12.5 10.5938 12.3125 10.5 12.125 10.5H11.625C12.4688 9.40625 13 8.03125 13 6.5C13 2.9375 10.0625 0 6.5 0C2.90625 0 0 2.9375 0 6.5C0 10.0938 2.90625 13 6.5 13C8 13 9.375 12.5 10.5 11.625V12.1562C10.5 12.3438 10.5625 12.5312 10.7188 12.6875L13.8125 15.7812C14.125 16.0938 14.5938 16.0938 14.875 15.7812L15.75 14.9062C16.0625 14.625 16.0625 14.1562 15.7812 13.8438ZM6.5 10.5C4.28125 10.5 2.5 8.71875 2.5 6.5C2.5 4.3125 4.28125 2.5 6.5 2.5C8.6875 2.5 10.5 4.3125 10.5 6.5C10.5 8.71875 8.6875 10.5 6.5 10.5Z" fill="#8F8F8F"/>
						</svg>
					</div>
					<input type="text" placeholder="Search a team" v-model="search">
				</div>
				<div class="find-teams__content-list">
					<TeamItem :team="team" v-for="(team, i) in teams" :key="i"></TeamItem>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import TeamItem from '@/components/teams/TeamItem'
import { TeamsService } from '../../services/teams.service'
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			search: '',
			teams: []
		}
	},
	components: {
		TeamItem
	},
	watch: {
		search () {
			this.getTeams()
		},
		currentGame () {
			this.getTeams()
		}
	},
	computed: {
		...mapGetters({
			currentGame: 'user/getCurrentGame'
		})
	},
	methods: {
		getTeams () {
				TeamsService.getTeams({
					limit: 10,
					page: 1,
					search: this.search ? this.search : undefined,
					game_id: this.currentGame ? this.currentGame.id : undefined,
					platform_id: this.currentGame ? this.currentGame.platformId : undefined
				}).then(response => {
					this.teams = response.data.data
				})
		}
	},
	mounted () {
		this.getTeams()
	}
}
</script>
<style scoped lang="scss">
	.find-teams {
		margin-top: 40px;
		.find-teams__content {
			.find-teams__content-input {
				width: 100%;
				background: #2F2F2F;
				border: 1px solid #505050;
				box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25), 0px 4px 15px rgba(0, 0, 0, 0.25);
				border-radius: 5px;
				margin-bottom: 25px;
				display: flex;
				align-items: center;
				height: 50px;
				padding: 0 15px;
				.icon {
					margin-right: 22px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				input {
					height: 100%;
					outline: none;
					border: none;
					flex-grow: 1;
					overflow: hidden;
					background: transparent;
					font-size: 10px;
					line-height: 20px;
					letter-spacing: 2px;
					text-transform: uppercase;
					color: #FFFFFF;
					&::placeholder {
						color: #fff
					}
				}
			}
		}
	}

	@media screen and (max-width: 575px) {
		.find-teams {
			margin-top: 16px;
			.find-teams__content {
				.find-teams__content-input {
					margin-bottom: 16px;
				}
				.find-teams__content-list {
					a {
						margin-bottom: 16px;
						padding: 10px;
					}
				}
			}
		}
	}
</style>
